// extracted by mini-css-extract-plugin
export default {"tokens":"\"../../styles/tokens.css\"","green":"#49D060","lightgray":"#E0E0E0","toggle":"styles_toggle__nDukS","slider":"styles_slider__LqQC8"};